import { render, staticRenderFns } from "./PianificazioneViaggioPartenza.vue?vue&type=template&id=5932127a&scoped=true&"
import script from "./PianificazioneViaggioPartenza.vue?vue&type=script&lang=js&"
export * from "./PianificazioneViaggioPartenza.vue?vue&type=script&lang=js&"
import style0 from "./PianificazioneViaggioPartenza.vue?vue&type=style&index=0&id=5932127a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932127a",
  null
  
)

export default component.exports